<template>
  <!--地址管理页面-->
  <tk-container :status="status">
    <!--头部-->
    <my-header slot="header">{{$route.query.type === 'new' ? '新增地址' : '编辑地址'}}</my-header>
    <!--间距-->
    <div style="height: 10px;"></div>
    <!--表单-->
    <tkui-form ref="form">
      <card :width="100" :height="100" class="p-0">
        <!--姓名-->
        <tk-flex class="flex-list flex-deep p-x-12">
          <tkui-input class="flex-list-input" label="收货人：" place-holder="请填写收货人姓名" noborder v-model="addressDetail.name"></tkui-input>
        </tk-flex>
        <div class="flex-border"></div>
        <!--手机号-->
        <tk-flex class="flex-list flex-deep p-x-12">
          <tkui-input class="flex-list-input" label="手机号：" type="telephone" rulers="required" place-holder="请填写收货人手机号" noborder v-model="addressDetail.phone"></tkui-input>
        </tk-flex>
        <div class="flex-border"></div>
        <!--所在地区-->
        <tk-flex class="flex-list p-y-2 p-x-12">
          <tkui-list class="full-width" v-if="showPicker">
            <tkui-list-picker style="border: 0;" class="full-width" type="region" v-model="addressDetail.region" left label="所在地区：" :regionFilter="regionFilter" placeholder="请选择地区"></tkui-list-picker>
          </tkui-list>
        </tk-flex>
        <div class="flex-border"></div>
        <!--门店详细地址-->
        <tk-flex class="flex-list account-basic-detail p-x-12">
          <tkui-input class="flex-list-input" noborder wrap-label label="详细地址：" :place-holder="'收货地址，务请详细'" v-model="addressDetail.address"></tkui-input>
        </tk-flex>
      </card>
      <!--设置默认地址-->
      <card :width="100" :height="50" class="p-12 m-t-10">
        <tk-flex middle between>
          <div class="font-14">设置默认地址</div>
          <div>
            <tkui-toggle v-model="switchDefault" type="switch"></tkui-toggle>
          </div>
        </tk-flex>
      </card>
    </tkui-form>
    <!--保存按钮-->
    <footer slot="footer">
      <div class="m-x-12 m-b-20">
        <tkui-button class="primary block raised rounded" @click="submit">保存</tkui-button>
      </div>
    </footer>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      showPicker: false,
      regionFilter: { // 地理位置
        root: '130000'
      },
      addressDetail: {
        name: '', // 收货人姓名
        phone: '', // 收货人电话
        region: '', // 所在地区
        address: '', // 详细地址
        default: 'no' // 默认地址切换
      }
    }
  },
  computed: {
    // 切换默认地址
    switchDefault: {
      get () {
        return this.addressDetail.default === 'yes'
      },
      set (v) {
        if (v === true) {
          this.addressDetail.default = 'yes'
        } else {
          this.addressDetail.default = 'no'
        }
      }
    }
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  methods: {
    /**
     * 初始化数据
     * @date: 2020/4/15
     */
    async getInit () {
      try {
        this.setStatusBar('dark')
        if (this.$route.query.id) {
          this.addressDetail = await this.$tkParse.getData(`/classes/shippingAddress/${this.$route.query.id}`)
        }
        this.showPicker = true
        this.status = false
      } catch (e) {
        this.showPicker = true
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
    * 判断是否有默认地址
    * @date: 2020/4/15
    */
    async judgeDefault () {
      let res = await this.$tkParse.getList('/classes/shippingAddress', {
        params: {
          limit: 10000,
          order: '-createdAt',
          where: {
            user: this.userInfo.objectId,
            default: 'yes'
          }
        }
      })
      return res
    },
    /**
    * 保存地址
    * @date: 2020/4/15
    */
    async submit () {
      // 表单校验
      if (this.$refs.form.validate().length > 0) { return }
      if (!this.addressDetail.region) { return this.$tkGlobal.toast.add('请选择地区') }
      try {
        this.status = 'waiting'
        if (this.$route.query.type === 'editor' && this.$route.query.id) { // 编辑
          await this.$tkParse.put(`/classes/shippingAddress/${this.$route.query.id}`, { default: this.addressDetail.default })
          let res = await this.judgeDefault()
          if (!res.length) {
            this.status = false
            await this.$tkParse.put(`/classes/shippingAddress/${this.$route.query.id}`, { default: 'yes' })
            return this.$tkGlobal.toast.add('您必须且只能保留一个默认地址')
          } else if (res.length > 1) {
            await this.$tkParse.put(`/classes/shippingAddress/${this.$route.query.id}`, { default: 'no' })
            let newRes = await this.judgeDefault()
            await this.$tkParse.put(`/classes/shippingAddress/${newRes[0].objectId}`, { default: 'no' })
            await this.$tkParse.put(`/classes/shippingAddress/${this.$route.query.id}`, this.addressDetail)
          } else {
            await this.$tkParse.put(`/classes/shippingAddress/${this.$route.query.id}`, this.addressDetail)
          }
        } else if (this.$route.query.type === 'new') { // 新增
          this.addressDetail.user = this.userInfo.objectId
          let defaultRes = await this.judgeDefault()
          let res = await this.$tkParse.post('/classes/shippingAddress/', this.addressDetail)
          this.addressDetail.objectId = res.data.objectId
          if (this.addressDetail.default !== 'no') {
            if (defaultRes.length) {
              await this.$tkParse.put(`/classes/shippingAddress/${defaultRes[0].objectId}`, {
                default: 'no'
              })
            }
          }
        }
        this.$setFlash('address', this.addressDetail)
        this.$tkGlobal.toast.add('保存成功！')
        this.$back()
      } catch (e) {
        this.status = false
        this.$tkGlobal.toast.add('保存失败，请重试')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  /*行样式*/
  .flex-list {
    width:100%;
    background-color: white;
    .flex-list-item {
      font-size: 14px;
      color: rgba(34, 34, 34, 1);
      line-height:10px;
    }
    .flex-list-input {
      width: 100%;
    }
    .flex-list-input ::placeholder {
      font-size: 14px;
      color: rgba(191, 191, 191, 1);
    }
  }
  .flex-border {
    width: 100%;
    height: 1px;
    background: #f5f5f5;
  }
  ::v-deep .tkui-list-item {
    border-bottom: 0 !important;
  }
  /*input内容样式*/
  .flex-deep {
    ::v-deep {
      .tkui-input-container .tkui-input-body-warp .tkui-input-body {
        margin-left: 16px;
      }
    }
  }
  ::v-deep .account-basic-detail .tkui-input-container .tkui-input-body-warp .tkui-input-body {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
  ::v-deep .tkui-list-picker-icon {
    width: 20px;
    height: 20px;
  }
</style>
